export default __webpack_public_path__ + "static/media/sounds/vocab_tqvm_practice_instruction_start_alyx.mp3";